import { AccountPlusOutlineIcon } from './AccountPlusOutlineIcon';

/**
 * author: GreenTurtwig
 * id 1095C7C6-C264-4415-BD6D-A2078242477E
 * name account-plus-outline
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-plus-outline.svg
 * tags
 * - Account / User 
 */
export const RegisterOutlineIcon = AccountPlusOutlineIcon;
export default RegisterOutlineIcon